module.exports = __webpack_public_path__ + "img/aeroland-tab-content-image-06.61829d3b.png";